"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = noop;
function noop() {}
module.exports = exports["default"];
//# sourceMappingURL=noop.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-netlify-form/dist/noop.js
// module id = 1995
// module chunks = 168707334958949